/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from '../../http/axios/index.js'

export default {
  addArchivoAdjunto ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post('/api/etapa-licitacion/add', item, {
        headers: {Authorization: `Bearer ${  localStorage.getItem('accessToken')}`}
      })
        .then((response) => {
          if (response.data.nuOk === 0) {
            item = response.data.id
            commit('ADD_ARCHIVOADJUNTO_CASO', item)
            resolve(response)
          } else {
            reject(response)
          }
        })
        .catch((error) => { reject(error) })
    })
  },
  setAllArchivosAdjuntosCaso ({ commit }, item) {
    return new Promise((resolve, reject) => {
      commit('SET_ARCHIVOADJUNTO_CASO', item)
      resolve(item)
    })
  },
  getAllArchivosAdjuntosCaso ({ commit }) {
    return new Promise((resolve, reject) => {

      axios.get('/api/etapa-licitacion', {
        headers: {Authorization: `Bearer ${  localStorage.getItem('accessToken')}`}
      })
        .then((response) => {
          commit('SET_ARCHIVOADJUNTO_CASO', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  getArchivosAdjuntosCasoByCaso ({ commit }, item) {
    return new Promise((resolve, reject) => {

      axios.get(`/api/etapa-licitacion/${item.IDLICITACION}`, {
        headers: {Authorization: `Bearer ${  localStorage.getItem('accessToken')}`}
      })
        .then((response) => {
          commit('SET_ARCHIVOADJUNTO_CASO', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateArchivoAdjunto ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post('/api/etapa-licitacion/update', item, {
        headers: {Authorization: `Bearer ${  localStorage.getItem('accessToken')}`}
      })
        .then((response) => {
          if (response.data.nuOk === 0) {
            commit('UPDATE_ARCHIVOADJUNTO_CASO', item)
            resolve(response)
          } else {
            reject(response)
          }
        })
        .catch((error) => { reject(error) })
    })
  },
  removeArchivoAdjuntoCaso ({ commit }, itemId) {
    return new Promise((resolve, reject) => {
      axios.post('/api/etapa-licitacion/delete', {id: itemId}, {
        headers: {Authorization: `Bearer ${  localStorage.getItem('accessToken')}`}
      })
        .then((response) => {
          if (response.data.nuOk === 0) {
            commit('REMOVE_ARCHIVOADJUNTO_CASO', itemId)
            resolve(response)
          } else {
            reject(response)
          }
        })
        .catch((error) => { reject(error) })
    })
  }
}
